// tags that need to be differentiated by x/y axis
export const graphAxisDuplicateTagWhitelist = [
	"Change from baseline",
	"Description",
	"Unit",
];

// tags that need to be differentiated by col/row header
export const tableHeaderDuplicateTagWhitelist = ["Comments", "Description"];

// tags that can have multiple values in a tag group
export const repeatTagWhitelist = ["Comments"];

// The two extraction roles - a curator does the extraction, a reviewer reviews
// completed extractions. Mirrors curatorRoleSlugs / reviewerRoleSlugs /
// extractionRoleSlugs in api/app/Constants.ts; keep the two files in step, since
// the frontend gates on these slugs independently of the API.
export const curatorRoleSlugs = ["curator"];
export const reviewerRoleSlugs = ["reviewer"];

// Roles whose holders do "real extraction work" - the curator who extracts plus
// the reviewer who reviews. Used to pick out the users a paper can be assigned to.
export const extractionRoleSlugs = [...curatorRoleSlugs, ...reviewerRoleSlugs];

// Must byte-for-byte match the API's auth-flag cookie name, which is
// `authenticated-${NODE_ENV}` (api/utils/CookieUtils.ts) - a THREE-valued
// discriminator: "development" | "staging" | "production". import.meta.env.MODE
// mirrors it because the deploy build runs `vite build --mode $ENVIRONMENT`
// (web/prod.Dockerfile) from the same environment name the API's NODE_ENV comes
// from, and the dev server's mode is "development". This reproduces the pre-Vite
// `"authenticated-" + process.env.NODE_ENV` name exactly in all three envs.
//
// Do NOT use the boolean import.meta.env.PROD: it is true for ANY non-dev build,
// so it collapses staging into "authenticated-production" while the API sets
// "authenticated-staging" - the SPA never finds the cookie and loops on SSO
// forever (staging-only). See DCTL-1973.
export const authCookieName = "authenticated-" + import.meta.env.MODE;

// Landing page for a contained prospect (DCTL-1931) who has no specific
// destination - they have no usable app surface beyond the Provenance Viewer,
// so the nav guard steers them here instead of the (forbidden) home dashboard.
export const PROSPECT_HOME_PATH = "/getting-started";

// app configuration
export const APP_NAME = "Dactyl™";

// AI pre-extraction readiness gate. A paper whose AI pre-extraction is still
// running is kept out of the extraction queues so nobody opens it unseeded.
// PAPER_PREPARING is the API's availability `reason` and 409 error `code` for
// such a paper (PREEXTRACT_PREPARING in api/app/services/PreextractJobService.ts);
// the message is the one every start surface shows for it.
export const PAPER_PREPARING = "preparing";
export const PAPER_PREPARING_MESSAGE =
	"This paper is still being prepared. Try again in a minute.";
// Paper Manager marker tooltip: the warning icon left of a held paper's name.
export const PAPER_PREPARING_MARKER_TOOLTIP = "Paper is pending pre-seeding";

// Kind ribbon colors for the activity timeline (admin metrics): one vivid,
// clearly separated hue per ribbon, deliberately NOT the muted theme colors,
// which were too close to tell apart at 5px. Validated 2026-08-17 with the
// dataviz palette checker, all pairs, against each other AND the orange
// active bar the ribbons sit under (normal vision + all three CVD
// simulations pass; the dark green vs mid red pair survives deutan on
// lightness). Orange itself is excluded: an orange ribbon under the orange
// active bar would vanish into it.
export const timelineKindColors = {
	orientation: "#2e7d32",
	text: "#03a9f4",
	graph: "#d32f2f",
	table: "#7b1fa2",
};
